import script from "./HangTonKhoPrintTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./HangTonKhoPrintTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./HangTonKhoPrintTemplate.vue?vue&type=style&index=0&id=2954d62c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2954d62c"]])

export default __exports__